// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__33Uqi","header":"ClearentDisclaimer_header__1Zc7h","inner":"ClearentDisclaimer_inner__1BFoi"};